import React from 'react'
import { useFormContext } from 'react-hook-form'

import RowDivider from '../../../common/components/RowDivider'
import Select from '../../../common/components/Select'
import {
    ChargePoint,
    useChargePointGetStatusIntervalsQuery,
    useCountrySettingsGetAllCountrySettingsQuery,
    useProductGetHardwareversionsQuery,
} from '../../../common/redux/api/web-api'
import { SContainer, SSubHeadings } from '../../../common/styles/Form'
import isAura from '../../../lib/isAura'
import Text from '../../../ui/Text'
import isHalo from '../../../lib/isHalo'

import { SCheckbox, SFormRow } from './charge-point-capi-details-widget.style'

interface IComponentProps {
    chargePoint: ChargePoint
}

const ChargePointDetailsSupportCapiInputs = ({ chargePoint }: IComponentProps) => {
    const { register } = useFormContext()

    const { data: statusIntervalsOptions } = useChargePointGetStatusIntervalsQuery()
    const { data: countriesSettingsOptions } = useCountrySettingsGetAllCountrySettingsQuery()
    const { data: hardwareVersionsOptions } = useProductGetHardwareversionsQuery(
        {
            productId: chargePoint.productId ?? 0,
        },
        {
            skip: !chargePoint.productId,
        }
    )

    const hwVersion = hardwareVersionsOptions?.flatMap((hardwareVersion) =>
        hardwareVersion.id === undefined ? [] : [{ key: hardwareVersion.id, value: hardwareVersion.description ?? '' }]
    )

    const countrySettings = countriesSettingsOptions?.flatMap((countrySetting) =>
        countrySetting.id === undefined ? [] : [{ key: countrySetting.id, value: countrySetting.countryName ?? '' }]
    )

    const statusIntervals = statusIntervalsOptions?.flatMap((statusInterval) =>
        statusInterval.id === undefined
            ? []
            : [{ key: Number(statusInterval.id), value: statusInterval.description ?? '' }]
    )

    return (
        <>
            <SFormRow>
                <label htmlFor="hardwareVersionId" data-testid="hw-field">
                    <Text code="lblHardwareVersion" />
                </label>
                <Select
                    id="hardwareVersionId"
                    options={hwVersion}
                    enableDefaultOption
                    {...register('hardwareVersionId', { valueAsNumber: true })}
                />
            </SFormRow>
            <SFormRow>
                <label htmlFor="countrySettingsId" data-testid="country-field">
                    <Text code="lblCountry" />
                </label>
                <Select
                    id="countrySettingsId"
                    options={countrySettings}
                    enableDefaultOption
                    {...register('countrySettingsId', { valueAsNumber: true })}
                />
            </SFormRow>
            <SFormRow>
                <label htmlFor="statusIntervalId" data-testid="interval-field">
                    <Text code="lblStatusUpdateInterval" />
                </label>
                <Select
                    id="statusIntervalId"
                    options={statusIntervals}
                    {...register('statusIntervalId')}
                    disabled={isHalo(chargePoint)}
                />
            </SFormRow>
            <RowDivider />
            <SContainer>
                <SSubHeadings data-testid="OCPP-toggle">
                    <Text code="lblChargerSettingsLink" />
                </SSubHeadings>
            </SContainer>
            <SFormRow>
                <SCheckbox htmlFor="debugEnabled">
                    <input
                        className="checkbox-black"
                        type="checkbox"
                        id="debugEnabled"
                        data-testid="debug-input"
                        {...register('debugEnabled')}
                    />
                    <span data-testid="debug-field">
                        <Text code="lblDebugEnabled" />
                    </span>
                </SCheckbox>
            </SFormRow>

            {isAura(chargePoint) && (
                <SFormRow>
                    <SCheckbox htmlFor="allowConnectCurrent">
                        <input
                            className="checkbox-black"
                            type="checkbox"
                            id="allowConnectCurrent"
                            data-testid="allowed-conn-input"
                            {...register('allowConnectCurrent')}
                        />
                        <span data-testid="allowed-conn-field">
                            <Text code="lblAllowConnectCurrentField" />
                        </span>
                    </SCheckbox>
                </SFormRow>
            )}
        </>
    )
}

export default ChargePointDetailsSupportCapiInputs
